import { createStore, applyMiddleware } from 'redux';
import createHistory from 'history/createHashHistory';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';

import reducers from 'reducers';

export const history = createHistory();

const configureStore = () => {
  const middleware = [thunk, routerMiddleware(history)];

  if (process.env.NODE_ENV !== 'production') {
    const logger = require('redux-logger').createLogger();
    middleware.push(logger);
  }

  return createStore(
    reducers,
    applyMiddleware(...middleware)
  );
};

export default configureStore();



// WEBPACK FOOTER //
// ./src/store.js